import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsQualcommComponent } from './simple-icons-qualcomm.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsQualcommComponent ],
    exports:      [ SimpleIconsQualcommComponent ],
    bootstrap:    []
})
export class SimpleIconsQualcommModule {}
